var video_viewer_default = {
  "video_player": "CkYyB",
  "videoOverlay": "KMVPw",
  "video_container": "v0RNb"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
